import { useTranslation } from 'react-i18next'
import { articlesPath, currentLocale, localeRootPath } from './i18n'

type PublicFooterProps = {
  standalone?: boolean
}

function FooterLogo({ href }: { href: string }) {
  const { t } = useTranslation()
  return (
    <a className="logo" href={href} aria-label={t('accessibility.backToTop')}>
      <span className="brand-mark brand-mark--compact" aria-hidden="true" />
      <span>SIDEWISP</span>
    </a>
  )
}

function GolemWorkersLockup() {
  return (
    <span className="golem-workers-lockup">
      <img src="/brand/golem-workers-mark.svg" width="28" height="31" alt="" />
      <strong>GOLEM WORKERS</strong>
    </span>
  )
}

function ArrowIcon() {
  return (
    <svg className="arrow-icon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <path d="M3.75 9h10.5M10 4.75 14.25 9 10 13.25" />
    </svg>
  )
}

export default function PublicFooter({ standalone = false }: PublicFooterProps) {
  const { t } = useTranslation()
  const locale = currentLocale()
  const localeRoot = localeRootPath(locale)
  const sectionPrefix = standalone ? localeRoot : ''

  return (
    <footer className={`site-footer${standalone ? ' site-footer--standalone' : ''}`}>
      <div className="site-footer__brand">
        <FooterLogo href={standalone ? localeRoot : '#top'} />
        <p>AI agent health, explained clearly.<br />Every action stays yours.</p>
      </div>
      <nav className="site-footer__links" aria-label="Footer">
        <span>EXPLORE</span>
        <a href={`${sectionPrefix}#product`}>PRODUCT</a>
        <a href={`${sectionPrefix}#checks`}>HEALTH CHECKS</a>
        <a href={`${sectionPrefix}#integrations`}>INTEGRATIONS</a>
        <a href={articlesPath(locale)}>{t('nav.articles').toUpperCase()}</a>
      </nav>
      <nav className="site-footer__links" aria-label="Legal">
        <span>LEGAL</span>
        <a href="/terms/">TERMS OF SERVICE</a>
        <a href="/privacy/">PRIVACY POLICY</a>
        <a href="mailto:info@sidewisp.com">CONTACT</a>
      </nav>
      <a
        className="site-footer__powered"
        href="https://golemworkers.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Powered by Golem Workers — a platform for launching AI agents"
      >
        <span className="site-footer__powered-label">POWERED BY</span>
        <div className="site-footer__powered-body">
          <GolemWorkersLockup />
          <p>A platform for launching AI agents.</p>
        </div>
        <span className="site-footer__powered-arrow" aria-hidden="true"><ArrowIcon /></span>
      </a>
      <div className="site-footer__bottom">
        <span>© 2026 SIDEWISP · A GOLEMWORKERS LLC PRODUCT</span>
        <span>{t('final.loop')}</span>
        <a href="mailto:info@sidewisp.com">INFO@SIDEWISP.COM</a>
      </div>
    </footer>
  )
}
